import { render } from "./client-certificate.vue?vue&type=template&id=8412d05c"
import script from "./client-certificate.vue?vue&type=script&lang=js"
export * from "./client-certificate.vue?vue&type=script&lang=js"

import "./client-certificate.vue?vue&type=style&index=0&id=8412d05c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__